const items = document.querySelectorAll("#main-image-slide li");
const leng = items.length;
items.forEach((item, index) => {
  const img = item.querySelector("img").src;
  if (img.indexOf("KV") !== -1) {
    item.classList.add("top");
  }
});
let isInit = false;
// let pos = Math.floor(Math.random() * leng);
let pos = -1;

function mainImageSlide() {
  gsap.set(items, { zIndex: 1 });
  if (items[pos]) {
    gsap.set(items[pos], { zIndex: 2 });
    gsap.to(items[pos], {
      filter: "blur(24px)",
      opacity: 0.25,
      duration: 7,
      ease: "power1.in",
    });
  }
  ++pos >= leng && (pos = 0);
  gsap.fromTo(
    items[pos],
    { opacity: 0 },
    {
      opacity: 1,
      duration: isInit ? 9 : 2,
      ease: "power1.inOut",
    }
  );
  gsap.fromTo(
    items[pos],
    { zIndex: 3, scale: 1.05, filter: "blur(0px)" },
    {
      scale: 1,
      duration: 9,
      ease: "power1.inOut",
    }
  );
  isInit = true;
}

setInterval(() => {
  mainImageSlide();
}, 7500);
mainImageSlide();
